/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Client_SinceInputs */

const en_features_client_since = /** @type {(inputs: Features_Client_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client since March`)
};

const pl_features_client_since = /** @type {(inputs: Features_Client_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podopieczna od marca`)
};

/**
* | output |
* | --- |
* | "Client since March" |
*
* @param {Features_Client_SinceInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_client_since = /** @type {((inputs?: Features_Client_SinceInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Client_SinceInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_client_since(inputs)
	return en_features_client_since(inputs)
});